module.exports = __webpack_public_path__ + "static/favicon-2c88cee50c91ac130e2a2b193fc012bf.ico";